import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import Seo from 'components/seo';
import './style.scss';
import { IframeVideoPlayer } from '../../../components/videoPlayer';

const LiveStream = observer(() => {
  const scoreRef = useRef();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const url = params.get('url');
  const search = window.location.search.substring(1);

  return (
    <div className='video_area' ref={scoreRef}>
      <Seo
        title='네임드스코어:라이브스코어,실시간스코어,실시간중계,커뮤니티'
        description='네임드 스코어 - 전세계 모든 경기의 라이브스코어, 실시간스코어, 실시간문자중계 정보 제공'
        path={window.location.pathname}
      />
      <IframeVideoPlayer src={search} />
    </div>
  );
});

export default LiveStream;
